<template>
  <div class="h-screen flex w-full vx-row no-gutter items-center justify-center d-theme-dark-bg portal-b" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card class="portal-card d-theme-dark-light-bg d-theme-border-grey-light">
        <div slot="no-body" class="d-theme-dark-light-bg">
          <div class="vx-row no-gutter justify-center items-center d-theme-dark-light-bg">
            <div class="vx-col hidden lg:block lg:w-1/2 flex items-center justify-center p-6">
              <img src="@/assets/images/logo/itatlogowide.png" alt="ITAT" class="portal-logo">
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2">
              <div class="p-8">
                <div class="vx-card__title mb-4">
                  <h1 class="mb-4 d-theme-text-inverse portal-title">ITAT Time Tracker</h1>
                  <p class="d-theme-text-inverse portal-subtitle mb-6">{{ isCheckingSession ? 'Checking your session...' : 'Sign in to continue' }}</p>
                  <div v-if="isCheckingSession" class="portal-loader-wrap">
                    <div class="loading">
                      <div class="effect-1 effects"></div>
                      <div class="effect-2 effects"></div>
                      <div class="effect-3 effects"></div>
                    </div>
                    <img src="/logo-icon-x64.png" alt="Logo" class="portal-loader-logo">
                  </div>
                  <vs-button v-else class="portal-button" size="large" @click="LoginToTimeTracker()">Sign In</vs-button>
                  <p v-if="loginError" class="portal-error mt-4">{{ loginError }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { getDefaultScreenPath } from '@/utils/defaultScreen.js'

export default {
  data() {
    return {
      loginError: '',
      enteringApp: false
    }
  },
  computed: {
    isCheckingSession() {
      return this.$auth.loading || this.enteringApp
    }
  },
  methods: {
    LoginToTimeTracker() {
      this.loginError = ''
      this.$auth.loginWithRedirect({
        authorizationParams: { audience: process.env.VUE_APP_AUTH0_AUDIENCE },
        appState: { targetUrl: getDefaultScreenPath() }
      })
    },
    enterAppIfAuthenticated() {
      if (this.enteringApp) return
      this.enteringApp = true
      this.loginError = ''
      this.$store.dispatch('ActionFetchUserClient', null)
        .then(response => {
          if (response.data.User.WorkerType === 2) {
            this.$router.push('/dashboard')
          } else {
            this.$router.push(getDefaultScreenPath())
          }
        })
        .catch(() => {
          this.enteringApp = false
          this.loginError = 'Unable to load your account. You may not have access to Time Tracker.'
        })
    }
  },
  watch: {
    '$auth.loading': {
      handler(loading) {
        if (loading === false && this.$auth.isAuthenticated) {
          this.enterAppIfAuthenticated()
        }
      },
      immediate: true
    }
  },
  created() {
    document.title = 'ITAT Time Tracker - Sign In'
  },
  mounted() {
    if (!this.$auth.loading && this.$auth.isAuthenticated) {
      this.enterAppIfAuthenticated()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/vuexy/variables";

.portal-b {
  background-image: url(/img/vuexy-login-bg.04351a33.jpg);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
body.theme-dark .portal-b {
  background-image: none;
}
#page-login {
  ::v-deep .portal-card {
    border-radius: 0.5rem;
    overflow: hidden;
  }
  .portal-logo {
    max-width: 100%;
    height: auto;
    max-height: 80px;
  }
  .portal-title {
    font-size: 28px;
    font-weight: bold;
    color: $white !important;
  }
  body.theme-dark & .portal-title {
    color: $theme-dark-heading-color !important;
  }
  .portal-subtitle {
    font-size: 15px;
  }
  .portal-button {
    background: #2a53a8 !important;
  }
  .portal-button:hover {
    box-shadow: 0 8px 25px -8px #0582ad !important;
  }
  .portal-loader-wrap {
    position: relative;
    width: 74px;
    height: 74px;
    margin-bottom: 0.5rem;
  }
  .portal-loader-wrap .loading {
    position: absolute;
    top: 0;
    left: 0;
  }
  .portal-loader-logo {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 17px;
    left: 17px;
    object-fit: contain;
  }
  .portal-error {
    color: #dc2626;
    font-size: 14px;
  }
}
</style>
